// extracted by mini-css-extract-plugin
export default {"wrapper":"introduction8_wrapper__-gisE","button":"introduction8_button__Zpg+e"};